import PropTypes from "prop-types";
import React, { useState } from "react";

import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import { useFormik } from "formik";
import * as Yup from "yup";
import { post } from "../../api/axios";
import endpoints from "../../api/endpoints";
import logo from "../../assets/images/elevated-logo.svg";
import login from "../../assets/images/login.png";
import { Bounce, toast } from "react-toastify";

const UpdatePassword = (props) => {
  document.title = "Update Password | Elevated - Admin Dashboard";

  const navigate = useNavigate();
  const [apiError, setApiError] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedPassword, setIsFocusedPassword] = useState(false);
  const [isFocusedNew, setIsFocusedNew] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Please enter the OTP"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Please enter your new password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Please confirm your new password"),
    }),
    onSubmit: async (values) => {
      try {
        const resp = await post(endpoints.updatePassword, {
          token: values.otp,
          password: values.password,
        });

        if (resp?.data?.success) {
          navigate("/login");
          toast.success("Password has been updated successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          setApiError(
            toast.error("The OTP entered is incorrect. Please try again.", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            }),
            apiError
          );
        }
      } catch (error) {
        setApiError("An error occurred. Please try again.");
      }
    },
  });

  return (
    <>
      <div className=" account-pages bg-white">
        <Row className="d-flex align-items-center justify-content-center min-vh-100 g-0 px-3">
          <Col md="6" className="d-none d-xl-block">
            <div className="image-section">
              <img
                src={login}
                alt="Gym Equipment"
                className="object-fit-cover img-fluid w-100 rounded-5 "
                style={{ maxHeight: "96vh" }}
              />
            </div>
          </Col>
          <Col
            md="6"
            className="d-flex align-items-center justify-content-center login-scroll"
          >
            <div className="">
              <Link to="/" className="mb-3 d-block auth-logo mt-5">
                <img
                  src={logo}
                  alt="Logo"
                  height="80"
                  className="logo logo-light"
                />
              </Link>
            </div>

            <div className="pt-4 gap-0 ">
              <div className="login-container">
                <div className="login-form-wrapper">
                  <div className="logo text-center mb-4">
                    <img
                      src={logo}
                      alt="Elevated Iron Logo"
                      className="login-logo"
                    />
                  </div>
                  <h2 className="text-center mt-5 mb-0 ff-sora fw-bold font-size-24 primary-black">
                    New Password
                  </h2>
                  <p className="text-center ff-sora font-size-16 secondary-black fw-normal pt-2">
                    Enter your new password below to reset
                    <br /> your account password.
                  </p>

                  <Form
                    onSubmit={validation.handleSubmit}
                    className="login-form  mx-2 mx-xl-0"
                  >
                    <FormGroup floating>
                      <Input
                        type="text"
                        name="otp"
                        placeholder="Enter OTP"
                        className={`form-c rounded-pill ff-sora fw-normal font-size-16 primary-black email-input ${
                          validation.values.otp || isFocused
                            ? "bg-change"
                            : "bg-light"
                        }`}
                        value={validation.values.otp}
                        onChange={validation.handleChange}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                          setIsFocused(false);
                        }}
                        onFocus={() => setIsFocused(true)}
                        invalid={
                          validation.touched.otp && validation.errors.otp
                            ? true
                            : false
                        }
                        style={{
                          maxWidth: "548px",
                          backgroundColor:
                            validation.values.otp || isFocused
                              ? "#EBF5F4"
                              : "#F5F5F5",
                          border: "none",
                        }}
                      />
                      <Label className="light-black font-size-16 ff-sora fw-normal">
                        Enter OTP{" "}
                      </Label>
                      {validation.touched.otp && validation.errors.otp && (
                        <div className="text-danger">
                          {validation.errors.otp}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup floating>
                      <Input
                        type="password"
                        name="password"
                        placeholder="New Password"
                        className={`form-c rounded-pill ff-sora fw-normal font-size-16 primary-black email-input ${
                          validation.values.password || isFocusedPassword
                            ? "bg-change"
                            : "bg-light"
                        }`}
                        value={validation.values.password}
                        onChange={validation.handleChange}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                          setIsFocusedPassword(false);
                        }}
                        onFocus={() => setIsFocusedPassword(true)}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                            ? true
                            : false
                        }
                        style={{
                          maxWidth: "548px",
                          backgroundColor:
                            validation.values.password || isFocusedPassword
                              ? "#EBF5F4"
                              : "#F5F5F5",
                          border: "none",
                        }}
                      />
                      <Label
                        for="email"
                        className="light-black font-size-16 ff-sora fw-normal"
                      >
                        New Password
                      </Label>
                      {validation.touched.password &&
                        validation.errors.password && (
                          <div className="text-danger">
                            {validation.errors.password}
                          </div>
                        )}
                    </FormGroup>
                    <FormGroup floating>
                      <Input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm New Password"
                        className={`form-c rounded-pill ff-sora fw-normal font-size-16 primary-black email-input ${
                          validation.values.confirmPassword || isFocusedNew
                            ? "bg-change"
                            : "bg-light"
                        }`}
                        value={validation.values.confirmPassword}
                        onChange={validation.handleChange}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                          setIsFocusedNew(false);
                        }}
                        onFocus={() => setIsFocusedNew(true)}
                        invalid={
                          validation.touched.confirmPassword &&
                          validation.errors.confirmPassword
                            ? true
                            : false
                        }
                        style={{
                          maxWidth: "548px",
                          backgroundColor:
                            validation.values.confirmPassword || isFocusedNew
                              ? "#EBF5F4"
                              : "#F5F5F5",
                          border: "none",
                        }}
                      />
                      <Label
                        for="email"
                        className="light-black font-size-16 ff-sora fw-normal"
                      >
                        Confirm New Password
                      </Label>
                      {validation.touched.confirmPassword &&
                        validation.errors.confirmPassword && (
                          <div className="text-danger">
                            {validation.errors.confirmPassword}
                          </div>
                        )}
                    </FormGroup>

                    <FormGroup check>
                      <Label
                        check
                        className="font-size-14 ff-sora fw-normal secondary-black"
                      >
                        <Input
                          type="checkbox"
                          style={{ border: "1px solid black" }}
                        />{" "}
                        Log out from all other devices.
                      </Label>
                    </FormGroup>
                    <Button
                      type="submit"
                      className="custom-button bg-brand-orange rounded-pill font-size-16 fw-bold ff-sora mt-3"
                    >
                      Update Password
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(UpdatePassword);
